import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { BBIDService } from '@core/services/bbid.service';
import { SpinnerService } from '@core/services/spinner.service';
import { TokenService } from '@core/services/token/token.service';
import { BbidLinkFailedReason } from '@core/typings/auth.typing';
import { environment } from '@environment';
import { PanelTypes } from '@yourcause/common/panel';
import { I18nService } from '@yourcause/common/i18n';

@Component({
    selector: 'gc-bbid-already-exists-block',
    templateUrl: './bbid-already-exists-block.component.html',
    styleUrls: ['./bbid-already-exists-block.component.scss'],
    standalone: false
})
export class BbidAlreadyExistsBlockComponent implements OnInit {
  @Input() bbidEmail: string;
  @Input() gcEmail: string;
  @Input() initialRoute: string;
  @Input() failReason: BbidLinkFailedReason.BBID_LINKED_TO_ANOTHER_ACCOUNT|BbidLinkFailedReason.BBID_NON_LINKED_EMAIL_EXISTS_IN_GC;
  @Output() onSignInToExistingBbidAccount = new EventEmitter();

  PanelTypes = PanelTypes;
  description = '';

  constructor (
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private bbidService: BBIDService,
    private i18n: I18nService,
    private tokenService: TokenService
  ) { }

  ngOnInit () {
    if (this.failReason === BbidLinkFailedReason.BBID_LINKED_TO_ANOTHER_ACCOUNT) {
      this.description = this.i18n.translate(
        'common:textBbidTiedToAnotherAccountDesc',
        {
          email1: this.bbidEmail,
          email2: this.gcEmail
        },
        'You signed in to BBID with __email1__. This email is already associated with a GrantsConnect account and cannot be used to link __email2__.'
      );
    } else {
      this.description = this.i18n.translate(
        'common:textBbidTiedToAnotherAccountDesc2',
        {
          email1: this.bbidEmail
        },
        'You signed in to BBID with __email1__. This email is already associated with a GrantsConnect account.'
      );
    }
  }

  async signInToExistingBbidAccount () {
    if (this.failReason === BbidLinkFailedReason.BBID_LINKED_TO_ANOTHER_ACCOUNT) {
      this.spinnerService.startSpinner();
      const token = await this.bbidService.getToken();
      const parsed = this.tokenService.parseJwt(token);
      const clientId = await this.authService.getSelectedClientForUser(this.bbidEmail, parsed?.sub);
      await this.authService.loginWithBbid(
        environment.bbidGcServiceId,
        environment.bbidGcEnvironmentId,
        true,
        true,
        '',
        true,
        clientId
      );
      this.spinnerService.stopSpinner();
    } else {
      this.onSignInToExistingBbidAccount.emit();
    }
  }

  startBbidOver () {
    this.bbidService.logoutOfBbid(this.initialRoute);
  }
}
